import { EKOM_LINKS } from '../EKOM_LINKS'
import { iExtContractOut } from '../hooks/useContractsSlug'
import { iMsg, MSG_TYPES, iSubm } from '../types/msg.types'

export const findLink = (msg: iMsg | iSubm, slugData?: iExtContractOut[]) => {
  if (msg.type === MSG_TYPES.OPERATING || msg.type === MSG_TYPES.MARKETING) {
    return ''
  }
  const slug = slugData?.find(d => d.systemExtId === msg.systemExtId && d.objectExtId === msg.objectExtId)?.slug || ''
  return slug ?
    `${EKOM_LINKS.contractDetail}/${slug}` :
    `${EKOM_LINKS.contractVirtual}?${EKOM_LINKS.queryExtSys}=${msg.systemExtId}&${EKOM_LINKS.queryExtId}=${msg.objectExtId}`
}
